import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import AdminLayout from "../components/AdminLayout";
import { useAuth } from "../context/AuthContext";
import { Trash2 } from "lucide-react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const STATUSES = ["new", "contacted", "closed"];

const AdminContacts = () => {
  const { authHeaders } = useAuth();
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(`${API}/contacts`, { headers: authHeaders() });
      setContacts(data);
    } catch {
      toast.error("Gabim");
    } finally {
      setLoading(false);
    }
  }, [authHeaders]);

  useEffect(() => { load(); }, [load]);

  const updateStatus = async (id, status) => {
    try {
      await axios.patch(`${API}/contacts/${id}/status?status=${status}`, {}, { headers: authHeaders() });
      load();
    } catch {
      toast.error("Gabim");
    }
  };

  const onDelete = async (id) => {
    if (!window.confirm("Fshi këtë kontakt?")) return;
    try {
      await axios.delete(`${API}/contacts/${id}`, { headers: authHeaders() });
      load();
    } catch {
      toast.error("Gabim");
    }
  };

  return (
    <AdminLayout>
      <div data-testid="admin-contacts-page">
        <h1 className="text-3xl font-bold text-[#0A0A0A] mb-2" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>Kontaktet</h1>
        <p className="text-zinc-600 mb-8">Mesazhe nga klientë B2B</p>

        {loading ? (
          <div className="text-zinc-500">Duke ngarkuar...</div>
        ) : contacts.length === 0 ? (
          <div className="bg-white border border-zinc-200 p-12 text-center text-zinc-500">Asnjë mesazh ende</div>
        ) : (
          <div className="space-y-3">
            {contacts.map((c) => (
              <div key={c.id} className="bg-white border border-zinc-200 p-5">
                <div className="flex items-start justify-between gap-4">
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-3 mb-1 flex-wrap">
                      <h3 className="font-bold text-[#0A0A0A]">{c.name}</h3>
                      <span className="text-sm text-zinc-500">— {c.company}</span>
                    </div>
                    <div className="text-sm text-zinc-600 flex flex-wrap gap-4 mb-3">
                      {c.email && <span>{c.email}</span>}
                      {c.phone && <span>{c.phone}</span>}
                      <span className="text-zinc-400">{c.business_type}</span>
                    </div>
                    <p className="text-zinc-700 whitespace-pre-wrap">{c.message}</p>
                    <p className="text-xs text-zinc-400 mt-2">{new Date(c.timestamp).toLocaleString()}</p>
                  </div>
                  <div className="flex flex-col gap-2 items-end">
                    <select value={c.status} onChange={(e) => updateStatus(c.id, e.target.value)} className="text-sm border border-zinc-300 px-2 py-1 focus:border-[#0A0A0A] focus:outline-none">
                      {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
                    </select>
                    <button onClick={() => onDelete(c.id)} className="p-2 text-red-600 hover:bg-red-50">
                      <Trash2 className="w-4 h-4" />
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </AdminLayout>
  );
};

export default AdminContacts;
